import { createSlice } from "@reduxjs/toolkit";

const changePassword = createSlice({
  name: "ChangePassword",
  initialState: {},
  reducers: {
    /**
     * Home 画面に戻る
     */
    backToHome(state, action) {
      state.backToHome = true;
    },
    /**
     * フォーム入力
     */
    inputForm(state, action) {
      state.inputForm = state.inputForm || {};
      state.inputForm[action.payload.formId] = action.payload.value;
    },
    /**
     * UpdatePassword API 実行開始
     */
    requestUpdatePasswordApi(state, action) {
      state.isFetching = true;
      state.errorMessage = null;
    },
    /**
     * UpdatePassword API 成功
     */
    succeededUpdatePasswordApi(state, action) {
      state.isFetching = false;
      state.succeeded = true;
    },
    /**
     * API 通信結果のエラー表示
     */
    errorMessage(state, action) {
      state.errorMessages = action.payload.messages;
      state.isFetching = false;
    },
  },
});

const { reducer } = changePassword;
export const { actions } = changePassword;
export default reducer;
